import axios from 'axios';

export const login = ({ data }) => axios.post('/login', data, { authWithToken: false });

export const logout = () => axios.get('/logout');


export const mfa = ({ data }) => axios.post('/mfa', data, {  });


